module.exports = __webpack_public_path__ + "static/media/bamburgh-react-messenger-application-reactstrap-pro.895df192.jpg";